import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ConsentRoutingModule } from './consent-routing.module';
import { SharedModule } from '../shared/shared.module';
import { ConsentComponent } from './consent.component';

@NgModule({
  declarations: [ConsentComponent],
  imports: [CommonModule, FormsModule, IonicModule, TranslateModule, ConsentRoutingModule, SharedModule],
})
export class ConsentModule {}
